import React from "react";
import delivered from "../../../../assets/images/dashboard/icon/delivered.png";
import pending from "../../../../assets/images/dashboard/icon/pending.png";
import paid from "../../../../assets/images/dashboard/icon/paid.png";
import formateText from "../../../../utils/Formate";

const THEMES = {
  Shipped: {
    accent: "#2563eb",
    accentSoft: "rgba(37, 99, 235, 0.12)",
    bar: "#2563eb",
    label: "In transit & delivered",
  },
  Pending: {
    accent: "#ea580c",
    accentSoft: "rgba(234, 88, 12, 0.12)",
    bar: "#ea580c",
    label: "Awaiting payment or pickup",
  },
  Paid: {
    accent: "#15803d",
    accentSoft: "rgba(21, 128, 61, 0.12)",
    bar: "#15803d",
    label: "Successfully settled",
  },
};

const ICONS = [delivered, pending, paid];

const UserBookingRemaining = ({ id, name, value, total = 0, loading }) => {
  const theme = THEMES[name] || THEMES.Pending;
  const pct =
    total > 0 && Number.isFinite(Number(value))
      ? Math.min(100, Math.round((Number(value) / total) * 100))
      : 0;

  if (loading) {
    return (
      <div className="relative overflow-hidden min-h-[168px] w-full rounded-2xl border border-[#e8ddd4] bg-white p-5 animate-pulse shadow-sm">
        <div className="absolute left-0 top-0 h-full w-1.5 bg-stone-200" />
        <div className="flex justify-between gap-4">
          <div className="space-y-3 flex-1">
            <div className="h-4 w-20 rounded bg-stone-200" />
            <div className="h-10 w-16 rounded bg-stone-200" />
            <div className="h-3 w-32 rounded bg-stone-100" />
          </div>
          <div className="h-12 w-12 rounded-xl bg-stone-200" />
        </div>
        <div className="mt-6 h-2 w-full rounded-full bg-stone-100" />
      </div>
    );
  }

  return (
    <div
      className="group relative overflow-hidden min-h-[168px] w-full rounded-2xl border border-[#e8ddd4] bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
      style={{ boxShadow: "0 8px 24px rgba(109, 76, 65, 0.06)" }}
    >
      <div
        className="absolute left-0 top-0 h-full w-1.5"
        style={{ backgroundColor: theme.accent }}
      />
      <div
        className="pointer-events-none absolute -right-6 -top-6 h-28 w-28 rounded-full opacity-60 transition-transform duration-500 group-hover:scale-110"
        style={{ background: theme.accentSoft }}
      />

      <div className="relative flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-stone-500">
            {formateText(name)}
          </p>
          <p
            className="mt-2 text-4xl xl:text-5xl font-black tabular-nums tracking-tight text-stone-900"
            style={{ color: theme.accent }}
          >
            {value}
          </p>
          <p className="mt-1.5 text-xs font-medium text-stone-500">
            {theme.label}
          </p>
        </div>
        <div
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl"
          style={{ backgroundColor: theme.accentSoft }}
        >
          <img
            className="h-7 w-7 object-contain"
            src={ICONS[Math.max(0, (id || 1) - 1)] || ICONS[0]}
            alt=""
          />
        </div>
      </div>

      {total > 0 ? (
        <div className="relative mt-5">
          <div className="mb-1.5 flex items-center justify-between text-[11px] font-semibold text-stone-500">
            <span>{pct}% of portfolio</span>
            <span className="tabular-nums">
              {value}/{total}
            </span>
          </div>
          <div className="h-2 w-full overflow-hidden rounded-full bg-stone-100">
            <div
              className="h-full rounded-full transition-all duration-700 ease-out"
              style={{
                width: `${pct}%`,
                backgroundColor: theme.bar,
              }}
            />
          </div>
        </div>
      ) : (
        <div className="mt-5 h-2 w-full rounded-full bg-stone-100" />
      )}
    </div>
  );
};

export default UserBookingRemaining;
